"use client";

import axo from "@/lib/axo";
import { getCookie, hasCookie } from "cookies-next";
import { useAppDispatch } from "@/store/hooks";
import {
  addCartItem,
  setCartItems,
  setCartOffers,
  setCartSummary,
} from "@/store/features/cartSlice";
import { useCountryCode } from "./useCountryCode";

type AddToCardParams = {
  serviceId: number;
  eventId: number;
  eventDetailId: number;
  quantity: number;
};

interface CartOptionalParams {
  onSuccess?: (message?: string) => void;
  onError?: (error?: string) => void;
}

const useCart = (callbacks?: CartOptionalParams) => {
  const { country } = useCountryCode();
  const dispatch = useAppDispatch();

  const defaultParams = {
    countryCode: country || "us",
    guestUserId: hasCookie("guestId")
      ? String(getCookie("guestId"))
      : undefined,
  };

  const addToCart = (params: AddToCardParams) => {
    dispatch(
      addCartItem({
        ...params,
        ...defaultParams,
      })
    )
      .then(() => {
        callbacks?.onSuccess?.();
      })
      .catch(() => {
        callbacks?.onError?.();
      });
  };
  const changeQuantity = async (params: AddToCardParams) => {
    try {
      await axo.post("/update-cart-item", {
        ...params,
        ...defaultParams,
      });
    } catch (error) {
      console.log("error :>> ", error);
    }
  };
  const getCartItems = async (params?: {
    countryCode: string;
    guestUserId: string;
    couponCode?: string;
  }) => {
    try {
      const { data, status } = await axo.get("/get-cart-item", {
        params: {
          ...defaultParams,
          ...params,
        },
      });
      if (status === 200) {
        dispatch(setCartItems(data?.cartItems));
        dispatch(setCartOffers(data?.offers));
        dispatch(setCartSummary(data?.cartSummary));
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  return {
    addToCart,
    changeQuantity,
    getCartItems,
  };
};

export default useCart;
